import type { History } from 'history';
import React from 'react';
import type { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router';

export const RootHistoryContext = React.createContext<Nullable<History>>(null);

const RootHistoryContextProvider: React.FC<RouteComponentProps> = ({ history, children }) => (
  <RootHistoryContext.Provider value={history}>{children}</RootHistoryContext.Provider>
);

export default withRouter(RootHistoryContextProvider);
